import React from "react";

import { ErrorMessage, SingleSelect, TextField } from "widgets";
import {
  DURATION_TYPES,
  FEATURES,
  SERVICE_OFFERINGS,
} from "constants/config";
import { useServiceUsageDate } from "store/backend/apiHooks";
import Loader from "shared/Loader/Loader";

import styles from "./AddPackageFeatureOffering.module.scss";

const Field = ({ title, component, error }) => (
  <div className={styles.fieldsDisplay}>
    <span className={styles.title}>{title}</span>
    {component}
    {error && <ErrorMessage>{error}</ErrorMessage>}
  </div>
);

const AddServiceOffering = (props) => {
  const { offering, handleServiceFeatureOffering, errors } = props;
  const {
    data: serviceUsageDates,
    isLoading: serviceUsageDatesIsLoading,
    error: serviceUsageDateErrorMessage,
    isError: isErrorServiceUsageDate
  } = useServiceUsageDate();

  const isQuantityFilled = offering.quantity !== "";
  const isDurationFilled =
    offering.duration !== "" && offering.durationType?.value !== "";

  return (
    <div className={styles.serviceTypeOfferingContainer}>
      <div className={styles.dropdown}>
        <Field
          title="Offering"
          component={
            <SingleSelect
              menuItems={SERVICE_OFFERINGS}
              value={offering.offering}
              placeholder="Select Offering Name"
              handleChange={(event) =>
                handleServiceFeatureOffering({
                  ...offering,
                  offering: event.target.value,
                })
              }
            />
          }
          error={errors && errors?.offering?.value}
        />
      </div>

      <div className={styles.fieldContainer}>
        <Field
          title="Feature"
          component={
            <SingleSelect
              menuItems={FEATURES}
              value={offering.feature}
              placeholder="Select Feature Name"
              handleChange={(event) =>
                handleServiceFeatureOffering({
                  ...offering,
                  feature: event.target.value,
                })
              }
            />
          }
          error={errors && errors?.feature?.value}
        />
        {serviceUsageDatesIsLoading ? (
          <Loader />
        ) : (
          <Field
            title="Usage Date"
            component={
              <SingleSelect
                menuItems={serviceUsageDates || []}
                value={offering.usageDate}
                placeholder="Select usage date"
                handleChange={(event) =>
                  handleServiceFeatureOffering({
                    ...offering,
                    usageDate: event.target.value,
                  })
                }
              />
            }
            error={isErrorServiceUsageDate ?serviceUsageDateErrorMessage : errors && errors?.usageDate?.value}
          />
        )}
      </div>
      <div className={styles.description}>
        <Field
          title="Feature Offering Description"
          component={
            <textarea
              value={offering.description}
              placeholder="Enter description"
              onChange={(event) =>
                handleServiceFeatureOffering({
                  ...offering,
                  description: event.target.value,
                })
              }
              className={styles.descriptionTextField}
            />
          }
          error={errors && errors?.description}
        />
      </div>
      <div className={styles.flexContainer}>
        <Field
          title="Quantity"
          component={
            <TextField
              value={offering.quantity}
              placeholder="Enter quantity"
              onChange={(event) =>
                handleServiceFeatureOffering({
                  ...offering,
                  quantity: event.target.value,
                })
              }
              disabled={isDurationFilled}
            />
          }
          error={errors ? errors.quantity : ""}
        />
        <Field
          title="Duration"
          component={
            <TextField
              value={offering.duration}
              placeholder="Enter duration"
              onChange={(event) =>
                handleServiceFeatureOffering({
                  ...offering,
                  duration: event.target.value,
                })
              }
              disabled={isQuantityFilled}
            />
          }
          error={errors ? errors.duration : ""}
        />
        <Field
          title="Duration Type"
          component={
            <SingleSelect
              menuItems={DURATION_TYPES}
              value={offering.durationType}
              placeholder="Select Duration Type"
              handleChange={(event) =>
                handleServiceFeatureOffering({
                  ...offering,
                  durationType: event.target.value,
                })
              }
              disabled={isQuantityFilled}
            />
          }
          error={errors && errors?.durationType}
        />
      </div>
    </div>
  );
};
export default AddServiceOffering;
